import { useUIStore } from '../../store/ui';
import { LeftColumn } from '../left/LeftColumn';
import { CenterColumn } from '../center/CenterColumn';
import { RightColumn } from '../right/RightColumn';

export function Workspace() {
  const activeDealId = useUIStore(s => s.activeDealId);
  if (!activeDealId) return null;
  return (
    <div className="workspace">
      <LeftColumn dealId={activeDealId} />
      <CenterColumn dealId={activeDealId} />
      <RightColumn dealId={activeDealId} />
    </div>
  );
}
